import React, { useEffect, useState, useRef } from "react";
import CustomTabs from "../../Shared/CustomTabs";
import styled, { css } from "styled-components";
import { colors } from "../../../../utils";
import DetailsTab from "../DetailsTab";
import DesignTab from "../DesignTab";
import PrivacyTab from "../PrivacyTab";
import SettingsTab from "../SettingsTab";
import { ASSETS } from "../../../../utils/config";
import TextView from "../../../TextView";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setWheelSettingsTab } from "../../../../redux/reducers/wheelSettings";
import { getWheelSettingsTab } from "../../../../redux/selectors/wheelSettingsSelectors";
import { clearDesignTabTarget } from "../../../../redux/reducers/segmentBuilder";
import { getDesignTabTarget } from "../../../../redux/selectors/segmentBuilderSelectors";

const tabOptions = new Map([
  ["0", { label: "Info", component: <DetailsTab /> }],
  ["1", { label: "Design", component: <DesignTab /> }],
  ["2", { label: "Access", component: <PrivacyTab /> }],
  // ["3", { label: "Settings", component: <SettingsTab /> }],
  // ["4", { label: "List", component: <ListTab /> }],
]);

const Container = styled.div`
  min-width: 30vw;
  background-color: ${colors.white};
  padding: 24px 16px 0px 16px;
  border-left: 1px solid ${colors.lightBorder};
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  height: 92vh;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(1px);
    `}
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  height: 44px;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${colors.lightBorder};
`;

export default function Sidepane({ isVisible, onClose }) {
  const dispatch = useDispatch();
  const selectedTab = useSelector(getWheelSettingsTab);
  const designTabTarget = useSelector(getDesignTabTarget);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    // Handle navigation to Design tab when designTabTarget is set
    if (designTabTarget === "segments") {
      dispatch(setWheelSettingsTab("1")); // "1" is the Design tab
    }
  }, [designTabTarget]);

  useEffect(() => {
    if (!isVisible) {
      // Reset tabs and clear navigation target when sidebar closes
      dispatch(setWheelSettingsTab("0"));
      dispatch(clearDesignTabTarget());
    } else {
      // Reset scroll position when sidepane becomes visible
      setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollTop = 0;
        }
      }, 100);
    }
    return () => {
      dispatch(setWheelSettingsTab("0"));
      dispatch(clearDesignTabTarget());
    };
  }, [isVisible]);

  const handleTabChange = (e, newVal) => {
    dispatch(setWheelSettingsTab(newVal));
  };

  return (
    <Container isVisible={isVisible} data-testid="wheel-settings-panel">
      <Header>
        <img src={ASSETS.wheelSetting} style={{ marginRight: 10 }} />
        <TextView variant="title" style={{ height: "100%" }}>
          Wheel Settings
        </TextView>
      </Header>
      <div
        ref={scrollContainerRef}
        style={{
          overflowY: "auto",
          height: "calc(92vh)",
          maxHeight: "calc(92vh - 80px)",
        }}
      >
        <CustomTabs
          selectedTab={selectedTab}
          handleTabChange={handleTabChange}
          options={tabOptions}
        />
      </div>
    </Container>
  );
}
